module.exports = __webpack_public_path__ + "img/full-04.d8bb9615.png";